export default __webpack_public_path__ + "static/media/notif_inprogress.ef8d1ee2.svg";